import { CommanderThunkAction } from '@mews-commander/types';
import { createPollerActions } from '@mews-commander/utils';
import { createAction, WEBSOCKET_CONNECTED, WEBSOCKET_DISCONNECTED, WEBSOCKET_MESSAGE_SENT } from '@mews/framework';
import { forceReload, logError } from '../../modules/app/actions/common';
import { connectionLost } from '../connection/actions';
import { WEBSOCKET_SUBSCRIBED, WEBSOCKET_UNSUBSCRIBED } from './actionTypes';
import { WEBSOCKET_RECONNECT_INTERVAL } from './constants';
import { isSubscriptionTypeSubscribed } from './selectors';

export function connectToWebsocket() {
    return (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        dispatch(createAction(WEBSOCKET_CONNECTED, container().apiComponent.getWebSocketUrl()));
    };
}

export const disconnectFromWebsocket = () => createAction(WEBSOCKET_DISCONNECTED);

export const subscribe =
    (subscriptionType: $TSFixMe, { type, profileIds, scopeIds }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe) => {
        const isAlreadySubscribed = isSubscriptionTypeSubscribed(getState(), { subscriptionType });
        dispatch(createAction(WEBSOCKET_SUBSCRIBED, subscriptionType));
        if (!isAlreadySubscribed) {
            dispatch(createAction(WEBSOCKET_MESSAGE_SENT, { type, profileIds, scopeIds }));
        }
    };

export const unsubscribe =
    (subscriptionType: $TSFixMe, { type }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe) => {
        dispatch(createAction(WEBSOCKET_UNSUBSCRIBED, subscriptionType));
        const isSubscribed = isSubscriptionTypeSubscribed(getState(), { subscriptionType });
        if (!isSubscribed) {
            dispatch(createAction(WEBSOCKET_MESSAGE_SENT, { type }));
        }
    };

export const createWebsocketSubscriptionActions = (actionType: $TSFixMe, websocketRequestTypeName: $TSFixMe) => {
    const handleSubscribe =
        ({ accountIds, profileIds, scopeIds }: $TSFixMe): CommanderThunkAction =>
        (dispatch: $TSFixMe) =>
            dispatch(subscribe(actionType, { type: websocketRequestTypeName, accountIds, profileIds, scopeIds }));
    const handleUnsubscribe = (): CommanderThunkAction => (dispatch: $TSFixMe) =>
        dispatch(unsubscribe(actionType, { type: websocketRequestTypeName }));

    return [handleSubscribe, handleUnsubscribe] as const;
};

export const [onClose, onOpen] = createPollerActions(connectToWebsocket, WEBSOCKET_RECONNECT_INTERVAL, {
    startImmediately: false,
    progressive: true,
    // @ts-expect-error $TSFixMeError: Argument of type '{ startImmediately: false; progressive: true; randomized: boolean; }' is not assignable to parameter o...
    randomized: true,
});

export function onError() {
    return (dispatch: $TSFixMe) => {
        dispatch(connectionLost());
    };
}

export const handleExpiredSession = () => (dispatch: $TSFixMe) => {
    dispatch(
        logError({
            type: 'force-reload',
            message: 'Forced reload caused by session expiration delivered via websockets.',
        })
    );
    dispatch(forceReload());
};
